export const siteConfig = {
  name: "WebNaTak",
  email: "kontakt@webnatak.pl",
  phone: "+48 573 195 600",
  address: "ul. Konopnickiej 13 U3, 58-100 Świdnica",
  workingHours: "Pon-Pt 9:00-17:00, Sob 10:00-14:00",
  whatsappUrl: "https://wa.me/48573195600",
  telegramUrl: "https://t.me/webnatak",
};

export const navLinks = [
  { name: "Jak to działa", path: "/jak-to-dziala" },
  { name: "Cennik", path: "/cennik" },
  { name: "Portfolio", path: "/portfolio" },
  { name: "Blog", path: "/blog" },
  { name: "Kontakt", path: "/kontakt" },
];

export const servicesDropdown = [
  { name: "Strony w abonamencie", path: "/strony-internetowe-w-abonamencie" },
  { name: "Opieka nad stroną", path: "/opieka-nad-strona-internetowa" },
  { name: "Strony w Świdnicy", path: "/strony-internetowe-swidnica" },
  { name: "Salony kosmetyczne", path: "/strona-dla-salonu-kosmetycznego" },
  { name: "Gabinety lekarskie", path: "/strona-dla-lekarza" },
  { name: "Restauracje", path: "/strona-dla-restauracji" },
  { name: "Firmy budowlane", path: "/strona-dla-firmy-budowlanej" },
  { name: "Fotografowie", path: "/strona-dla-fotografa" },
  { name: "Prawnicy", path: "/strona-dla-prawnika" },
];

export const features = [
  {
    icon: "Globe",
    title: "Profesjonalne projekty",
    description: "Indywidualnie dopasowane strony do Twojej branży i potrzeb",
  },
  {
    icon: "Palette",
    title: "Pełna obsługa",
    description: "Od projektu po wdrożenie - zajmujemy się wszystkim za Ciebie",
  },
  {
    icon: "Zap",
    title: "Szybka realizacja",
    description: "Twoja strona gotowa w 7-14 dni roboczych",
  },
  {
    icon: "Shield",
    title: "Gwarancja jakości",
    description: "Hosting, SSL, aktualizacje i wsparcie techniczne w cenie",
  },
];

export const stats = [
  { value: "100+", label: "Zadowolonych klientów" },
  { value: "500+", label: "Gotowych szablonów" },
  { value: "99.87%", label: "Dostępność serwisu" },
];

export const processSteps = [
  {
    number: "1",
    title: "Kontakt",
    description: "Skontaktuj się z nami w dowolny sposób - przez formularz, telefon, e-mail lub WhatsApp. Jesteśmy dostępni i gotowi na rozmowę.",
    items: ["Formularz kontaktowy", "Rozmowa telefoniczna", "E-mail", "WhatsApp"],
  },
  {
    number: "2",
    title: "Pomysł i wizja",
    description: "Opowiedz nam o swoich potrzebach i wizji. Pokażemy Ci propozycje projektów i rozwiązań dopasowanych do Twojej branży.",
    items: ["Analiza potrzeb", "Propozycje projektów", "Dobór rozwiązań", "Konsultacja"],
  },
  {
    number: "3",
    title: "Umowa i start",
    description: "Jeśli wszystko pasuje, podpisujemy umowę na minimum rok i rozpoczynamy prace nad Twoją stroną internetową.",
    items: ["Umowa na 12 miesięcy", "Ustalenie szczegółów", "Start projektu", "Harmonogram prac"],
  },
  {
    number: "4",
    title: "Gotowa strona",
    description: "Po około tygodniu otrzymujesz gotową, profesjonalną stronę internetową. Płacisz tylko miesięczny abonament - bez opłat startowych.",
    items: ["Strona gotowa w ~7 dni", "Tylko miesięczny abonament", "Brak opłat startowych", "Pełne wsparcie"],
  },
];

export const whyChooseUs = [
  {
    value: "0zł",
    title: "Bez opłat startowych",
    description: "Płacisz tylko miesięczny abonament. Żadnych ukrytych kosztów czy opłat za rozpoczęcie projektu.",
  },
  {
    value: "7",
    title: "Szybka realizacja",
    description: "Twoja strona będzie gotowa w około tygodnia. Nie czekasz miesięcy - działamy szybko i efektywnie.",
  },
  {
    value: "24/7",
    title: "Pełne wsparcie",
    description: "Hosting, SSL, aktualizacje i wsparcie techniczne - wszystko w cenie miesięcznego abonamentu.",
  },
];

export const contactMethods = [
  {
    icon: "Phone",
    title: "Telefon",
    value: "+48 573 195 600",
    link: "tel:+48573195600",
    buttonText: "Wybierz",
  },
  {
    icon: "Mail",
    title: "E-mail",
    value: "kontakt@webnatak.pl",
    link: "mailto:kontakt@webnatak.pl",
    buttonText: "Wybierz",
  },
  {
    icon: "FileText",
    title: "Formularz",
    value: "Wypełnij formularz kontaktowy",
    link: "/contact",
    buttonText: "Wybierz",
    isInternal: true,
  },
];

export const pricingPlans = [
  {
    name: "Start",
    price: "99",
    oldPrice: "199",
    period: "Miesięczny",
    description: "Idealny dla początkujących i małych projektów.",
    features: [
      "projekt i wdrożenie 1 strony na wybranym szablonie + personalizacja kolorów/logo/treści,",
      "hosting + SSL + podstawowe bezpieczeństwo,",
      "formularz kontaktowy → e-mail (1 integracja),",
      "konfiguracja GA4 / Tag Manager,",
      "podstawowe SEO (title/description + nagłówki + sitemap + robots),",
      "kopie zapasowe tygodniowe,",
      "1 drobna zmiana/mies. (do ~30 min),",
      "czas reakcji wsparcia: do 72 h",
    ],
    popular: false,
    buttonText: "Wybierz Plan Start",
  },
  {
    name: "Pro",
    price: "189",
    oldPrice: "289",
    period: "Miesięczny",
    description: "Rozwiń swój biznes z zaawansowanymi funkcjami.",
    features: [
      "wszystko z Start,",
      "dodatkowe sekcje/komponenty w obrębie tej samej strony (np. FAQ i referencje),",
      "do 3 integracji (np. CRM/HubSpot lub Pipedrive/czat/piksel Meta),",
      "2 języki,",
      "kopie zapasowe co 2 dni,",
      "do 3 drobnych zmian/mies. (łącznie ~90 min),",
      "czas reakcji: do 24 h",
    ],
    popular: true,
    buttonText: "Wybierz Plan Pro",
  },
  {
    name: "Biznes+",
    price: "279",
    oldPrice: "379",
    period: "Miesięczny",
    description: "Kompleksowe rozwiązanie dla dużych firm i e-commerce.",
    features: [
      "wszystko z Pro,",
      "do 5 integracji (np. CRM/chat/ rezerwacje/booking lub płatności za konsultację WhatsApp),",
      "3 języki,",
      "audyt wydajności i SEO kwartalnie + optymalizacje,",
      "kopie zapasowe codziennie,",
      "do 6 drobnych zmian/mies. (łącznie ~180 min),",
      "priorytetowe wsparcie: reakcja do 8h + 100 GB miejsca + dedykowany opiekun + integracje e-commerce + analityka premium",
    ],
    popular: false,
    buttonText: "Wybierz Plan Biznes+",
  },
];

export const blogPosts = [
  {
    slug: "jak-powinna-wygladac-strona-internetowa-dla-malej-firmy",
    title: "Jak powinna wyglądać dobra strona internetowa dla małej firmy?",
    excerpt: "Każda mała firma może wyglądać profesjonalnie w internecie - wystarczy dobrze zaprojektowana strona internetowa. W tym artykule dowiesz się, jak zaprojektować stronę www, która nie tylko dobrze wygląda, ale też przyciąga klientów i sprzedaje.",
    image: "https://static.wixstatic.com/media/11062b_c9033e5ead4c4760ab8e05e709d55a85~mv2.jpg/v1/fill/w_600,h_600,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/11062b_c9033e5ead4c4760ab8e05e709d55a85~mv2.jpg",
    imageLarge: "https://static.wixstatic.com/media/11062b_c9033e5ead4c4760ab8e05e709d55a85~mv2.jpg/v1/fill/w_1200,h_1200,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/11062b_c9033e5ead4c4760ab8e05e709d55a85~mv2.jpg",
    author: "Zespół WebNaTak",
    date: "24 października 2025",
    readTime: "2 min",
    content: [
      { type: "heading", text: "1. Pierwsze wrażenie – nowoczesny design ma znaczenie" },
      { type: "paragraph", text: "Twoja strona to wizytówka firmy. Użytkownik potrzebuje zaledwie kilku sekund, by zdecydować, czy zostanie, czy kliknie 'wstecz'. Dlatego tak ważny jest nowoczesny projekt strony www - z prostym układem, dużą typografią i spójnymi kolorami." },
      { type: "list", title: "Kluczowe elementy:", items: ["czytelne logo i menu,", "zdjęcie lub wideo nagłówkowe pokazujące Twoją branżę,", "wyraźny przycisk 'Skontaktuj się' lub 'Zamów bez zobowiązań'."] },
      { type: "heading", text: "2. Struktura, która prowadzi użytkownika" },
      { type: "paragraph", text: "Dobra strona internetowa dla małej firmy powinna być logicznie zbudowana. Użytkownik musi od razu wiedzieć: kim jesteś, co oferujesz i jak się z Tobą skontaktować." },
      { type: "list", title: "Najczęstszy układ:", items: ["Strona główna – skrót oferty i zalety,", "O nas – pokazuje ludzką stronę marki,", "Usługi / Oferta,", "Opinie klientów,", "Kontakt z formularzem i mapą."] },
      { type: "heading", text: "3. UX – doświadczenie użytkownika ma kluczowe znaczenie" },
      { type: "paragraph", text: "UX (User Experience) to nie tylko ładny wygląd, ale też funkcjonalność." },
      { type: "list", title: "Zadbaj o:", items: ["szybkie ładowanie strony,", "dostosowanie do telefonów (responsywność),", "prosty język i krótkie akapity,", "widoczne przyciski akcji (CTA)."] },
      { type: "paragraph", text: "W Polsce ponad 70% użytkowników odwiedza strony z telefonów, więc mobilna wersja to obowiązek." },
      { type: "heading", text: "4. Zaufanie i konwersje – małe szczegóły, duży efekt" },
      { type: "list", title: "Dodaj elementy, które budują zaufanie:", items: ["logo partnerów lub certyfikatów,", "opinie klientów,", "sekcję 'Dlaczego my?',", "dane kontaktowe w stopce."] },
      { type: "paragraph", text: "To proste elementy, które potrafią zwiększyć liczbę zapytań nawet o 30–40%." },
      { type: "heading", text: "5. Profesjonalny projekt za mały budżet" },
      { type: "paragraph", text: "Nowoczesna strona internetowa nie musi kosztować fortuny. Dzięki gotowym szablonom WebNaTak możesz mieć profesjonalny projekt strony www już od 199 zł miesięcznie - bez opłat na start." },
    ],
  },
  {
    slug: "dlaczego-twoja-firma-potrzebuje-strony-internetowej",
    title: "Dlaczego Twoja firma potrzebuje profesjonalnej strony internetowej?",
    excerpt: "W dzisiejszych czasach brak strony internetowej to jak prowadzenie firmy bez szyldu. Klienci szukają usług i produktów przede wszystkim online, a pierwsze wrażenie często decyduje o tym, czy zostaną z Tobą na dłużej.",
    image: "https://static.wixstatic.com/media/11062b_134c4e7a6b5a4895a40129eec19b750f~mv2.jpg/v1/fill/w_600,h_600,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/11062b_134c4e7a6b5a4895a40129eec19b750f~mv2.jpg",
    imageLarge: "https://static.wixstatic.com/media/11062b_134c4e7a6b5a4895a40129eec19b750f~mv2.jpg/v1/fill/w_1200,h_1200,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/11062b_134c4e7a6b5a4895a40129eec19b750f~mv2.jpg",
    author: "Zespół WebNaTak",
    date: "20 października 2025",
    readTime: "2 min",
    content: [
      { type: "heading", text: "1. Strona www działa 24/7 - nawet wtedy, gdy śpisz" },
      { type: "paragraph", text: "Dobrze zaprojektowana strona internetowa jest Twoim najlepszym sprzedawcą. Działa przez całą dobę, prezentując Twoją ofertę, opinie klientów i dane kontaktowe. Klient nie musi czekać do poniedziałku - może zamówić produkt lub napisać do Ciebie w każdej chwili." },
      { type: "heading", text: "2. Buduje wiarygodność i zaufanie" },
      { type: "paragraph", text: "Firmy bez strony www często wzbudzają nieufność. Profesjonalna strona, z dobrym designem i czytelną strukturą, daje wrażenie solidności i stabilności. Dzięki niej klient czuje, że ma do czynienia z prawdziwą marką, a nie przypadkowym ogłoszeniem." },
      { type: "heading", text: "3. Wspiera promocję i pozycjonowanie" },
      { type: "paragraph", text: "Jeśli inwestujesz w SEO lub reklamy Google Ads, Twoja strona staje się centralnym punktem promocji. Każdy klik w reklamę czy post na Facebooku prowadzi właśnie tam - gdzie możesz przekonać klienta, że warto wybrać Ciebie." },
      { type: "heading", text: "4. Ułatwia kontakt i zwiększa sprzedaż" },
      { type: "paragraph", text: "Strona z dobrze zaprojektowanym formularzem kontaktowym, mapą i numerem telefonu zwiększa liczbę zapytań nawet o kilkadziesiąt procent. Dodaj przycisk 'Zamów bez zobowiązań' - a użytkownicy chętniej zostawią dane." },
      { type: "heading", text: "5. Tworzenie stron www nie musi być drogie" },
      { type: "paragraph", text: "Wielu przedsiębiorców myśli, że tworzenie stron www to koszt tysięcy złotych. Tymczasem dziś możesz mieć profesjonalną stronę internetową już od kilkuset złotych miesięcznie - z hostingiem, wsparciem i aktualizacjami w cenie." },
      { type: "heading", text: "Podsumowanie" },
      { type: "paragraph", text: "Dobra strona internetowa dla firmy to inwestycja, która szybko się zwraca. Pomaga zdobywać klientów, buduje zaufanie i działa non stop. Jeśli jeszcze jej nie masz - to najlepszy moment, by to zmienić." },
    ],
  },
];

export const footerLinks = {
  product: [
    { name: "Cennik", path: "/cennik" },
    { name: "Jak to działa", path: "/jak-to-dziala" },
    { name: "Portfolio", path: "/portfolio" },
    { name: "Blog", path: "/blog" },
    { name: "FAQ", path: "/faq" },
  ],
  services: [
    { name: "Strony w abonamencie", path: "/strony-internetowe-w-abonamencie" },
    { name: "Opieka nad stroną", path: "/opieka-nad-strona-internetowa" },
    { name: "Strony w Świdnicy", path: "/strony-internetowe-swidnica" },
  ],
  legal: [
    { name: "Polityka prywatności", path: "/polityka-prywatnosci" },
    { name: "Regulamin", path: "/regulamin" },
    { name: "Kontakt", path: "/kontakt" },
  ],
};
